import { reactive } from 'vue';
import { moduleAccessState, type MenuSection, type ModuleId } from '@botto/core';

/** Canonical side-nav order (SMS → Тарифы → CDP → Трекер). */
export const MODULE_ORDER: readonly ModuleId[] = ['sms', 'tariffs', 'cdp', 'tracker'];

interface MenuStore {
  sections: MenuSection[];
  /** Sections the current user may see (JWT permissions per module audience). */
  readonly visibleSections: MenuSection[];
  registerSection(section: MenuSection): void;
}

function sortSections(sections: MenuSection[]): void {
  sections.sort((a, b) => {
    const ai = MODULE_ORDER.indexOf(a.id);
    const bi = MODULE_ORDER.indexOf(b.id);
    return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
  });
}

export const menuStore: MenuStore = reactive({
  sections: [] as MenuSection[],
  get visibleSections(): MenuSection[] {
    const allowed = new Set(moduleAccessState.allowed);
    // Until access probe finishes, show nothing (avoids flash of all modules).
    if (!moduleAccessState.ready) return [];
    return this.sections.filter((s: MenuSection) => allowed.has(s.id));
  },
  registerSection(section: MenuSection) {
    const idx = this.sections.findIndex((s: MenuSection) => s.id === section.id);
    if (idx >= 0) this.sections.splice(idx, 1, section);
    else this.sections.push(section);
    sortSections(this.sections);
  },
});
